module.exports = __webpack_public_path__ + "static/media/icon_dice.68082f03.png";